export var Grades;
(function (Grades) {
    Grades[Grades["TBD"] = -2] = "TBD";
    Grades[Grades["PK"] = -1] = "PK";
    Grades[Grades["K"] = 0] = "K";
    Grades[Grades["G1"] = 1] = "G1";
    Grades[Grades["G2"] = 2] = "G2";
    Grades[Grades["G3"] = 3] = "G3";
    Grades[Grades["G4"] = 4] = "G4";
    Grades[Grades["G5"] = 5] = "G5";
    Grades[Grades["G6"] = 6] = "G6";
})(Grades || (Grades = {}));
export var GradeInfo = new Map([
    [Grades.TBD, { shortName: 'TBD', fullName: 'TBD' }],
    [Grades.PK, { shortName: 'PK', fullName: 'Pre-kindergarten' }],
    [Grades.K, { shortName: 'K', fullName: 'Grade K' }],
    [Grades.G1, { shortName: 'G1', fullName: 'Grade 1' }],
    [Grades.G2, { shortName: 'G2', fullName: 'Grade 2' }],
    [Grades.G3, { shortName: 'G3', fullName: 'Grade 3' }],
    [Grades.G4, { shortName: 'G4', fullName: 'Grade 4' }],
    [Grades.G5, { shortName: 'G5', fullName: 'Grade 5' }],
    [Grades.G6, { shortName: 'G6', fullName: 'Grade 6' }],
]);
export var isTbd = function (grade) { return grade && grade.toLowerCase() === 'tbd'; };
export var getGradeIndex = function (grade) {
    switch (grade) {
        case Grades.PK:
            return 1;
        case Grades.K:
            return 2;
        case Grades.G1:
            return 3;
        case Grades.G2:
            return 4;
        case Grades.G3:
            return 5;
        case Grades.G4:
            return 6;
        case Grades.G5:
            return 7;
        case Grades.G6:
            return 8;
        default:
            return 0;
    }
};
export var getGradeByValue = function (value) {
    switch (value) {
        case Grades.PK:
            return Grades.PK;
        case Grades.K:
            return Grades.K;
        case Grades.G1:
            return Grades.G1;
        case Grades.G2:
            return Grades.G2;
        case Grades.G3:
            return Grades.G3;
        case Grades.G4:
            return Grades.G4;
        case Grades.G5:
            return Grades.G5;
        case Grades.G6:
            return Grades.G6;
        default:
            return 0;
    }
};
